import Reveal from '@/components/base/Reveal';
import { useToast } from '@/components/base/ToastProvider';
import { categoryEntries } from '@/mocks/home';

export default function EntryStrip() {
  const { showToast } = useToast();

  return (
    <section className="w-full bg-background-50 py-12 md:py-14">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
            <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
              按圈层直接进入
            </h2>
            <p className="text-[13px] text-foreground-600">
              四大圈层分区整理，每个入口都能看到该圈层的最新条目与在库数量。
            </p>
          </div>
        </Reveal>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categoryEntries.map((entry, index) => (
            <Reveal key={entry.key} delay={index * 60}>
              <button
                type="button"
                onClick={() => showToast(`已进入「${entry.name}」分区，共 ${entry.count} 条在库条目`)}
                className="group flex h-full w-full flex-col rounded-lg border border-background-200/70 bg-background-50 p-5 text-left transition-colors hover:border-primary-300"
              >
                <span className="flex items-center justify-between">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                    <i className={`${entry.icon} flex h-5 w-5 items-center justify-center text-lg`} />
                  </span>
                  <span className="font-heading text-lg font-bold text-foreground-300 transition-colors group-hover:text-primary-500">
                    {entry.count}
                  </span>
                </span>
                <span className="mt-4 flex items-center gap-1.5 font-heading text-base font-bold text-foreground-950">
                  {entry.name}
                  <i className="ri-arrow-right-up-line flex h-4 w-4 items-center justify-center text-base text-primary-500 opacity-0 transition-opacity group-hover:opacity-100" />
                </span>
                <span className="mt-2 text-[13px] leading-6 text-foreground-600">{entry.desc}</span>
                <span className="mt-4 flex items-start gap-1.5 border-t border-background-200/70 pt-3 text-[12px] text-foreground-500">
                  <i className="ri-flashlight-line mt-0.5 flex h-3.5 w-3.5 shrink-0 items-center justify-center text-sm text-accent-600" />
                  <span className="truncate">最新：{entry.latest}</span>
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}